export default "__VITE_ASSET__667fc276__"